module.exports = __webpack_public_path__ + "static/equipment-tow-truck-d345b962fc0ba02f0279f2f900ff4aa9.jpg";